import * as React from 'react';
import { TopToolbar, useListContext, List, TextField, DateField, ReferenceField, EditButton, Pagination } from 'react-admin';
import { Card, CardActions, CardContent, CardHeader, Avatar, Grid } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';
import { Button, Toolbar } from '@material-ui/core';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import { getTsBuildInfoEmitOutputFilePath } from 'typescript';
import parse, { attributesToProps } from 'html-react-parser';
import Moment from 'moment';
import Box from '@material-ui/core/Box';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import ClubBlack from './ClubBlack.png'
//import PostPagination from './PostPagination';

const cardStyle = {
  width: 300,
  minHeight: 300,
  margin: '0.5em',
  display: 'inline-block',
  verticalAlign: 'top'
};


const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      width: '500',
      //margin:'0 auto',

    },

    imgBack: {
      //  flexGrow: 1,
      backgroundColor: '#f3f3f3',
      margin: '0 auto',
      textAlign: 'center',
    },

    space: {
      flexGrow: 1,
      backgroundColor: '#fff',
      margin: '0 auto',
      // textAlign:'center',
    },

    spaceB: {
     // flexGrow: 1,
     // backgroundColor: '#dadada',
      margin: '0 auto',
      // textAlign:'center',
    },

    blogBack: {
      //  flexGrow: 1,
      backgroundColor: '#e8e7e7',
      margin: '0 auto',
      // textAlign:'center',
    },

    paper: {
      padding: '5px',
      // margin: 2,
      // maxWidth: 1000,
      // width: '100%',
      backgroundColor: '#F7F7F7',
      // display: 'flex',
      // justifyContent:'center'
      border: 1,
      marginBottom: '5px',
    },
    image: {
      //width: 300,
      //height: 300,
      margin: '0 auto',

    },
    img: {
      margin: 'auto',
      display: 'block',
      maxWidth: '100%',
      maxHeight: '100%',
    },

    title: {
      //backgroundColor: '#F7F7F7',
      textAlign: 'left',
    },

    date1: {
      fontSize: 12,

    },

    backHeader: {
      padding: '2px',
      backgroundColor: '#fff',
    },

    more: {
      width: '15px'
    },

    MainDiv: {
      border:'5px solid #d4d2d040'
    }



  }),
);


const ListActions = (props) => (
  <TopToolbar>

  </TopToolbar>
);

const PostPagination = () =>
{
  const { page, perPage, total, setPage } = useListContext();
  const nbPages = Math.ceil(total / perPage) || 1;
  return (
    nbPages > 1 &&
    <Toolbar>
      {page > 1 &&
        <Button color="primary" key="prev" onClick={() => setPage(page - 1)}>
          <ChevronLeft />
          Назад
        </Button>
      }
      {page !== nbPages &&
        <Button color="primary" key="next" onClick={() => setPage(page + 1)}>
          Далее
          <ChevronRight />
        </Button>
      }
    </Toolbar>
  );
}

const options = {
  replace: domNode =>
  {
    if (domNode.attribs && domNode.name === 'main')
    {
      const props = attributesToProps(domNode.attribs);
      return <div {...props} />;
    }
  }
};


const CommentGrid = () =>
{
  const classes = useStyles();
  const { ids, data, basePath } = useListContext();

  return ( 

    <div className={classes.root}>


      {ids.map(id => (

        // data.map(id =>
         <Paper className={classes.paper} key={data[id].id}>
         {/* <div className={classes.MainDiv}> */}
          <Grid container spacing={1} >
            <Grid item xs={10} sm={10} className={classes.backHeader} >

              <Typography align="left" variant="body1" className={classes.date1}>
                {Moment(data[id].creationDate).format('DD.MM.yyyy')}
              </Typography>
              </Grid>
            <Grid item xs={2} sm={2} className={classes.backHeader}> 
              <Typography align="right" className={classes.date1}>
                <a href={process.env.PUBLIC_URL+'/blog/' + data[id].id + '/show'}><MoreHorizIcon className={classes.more} /></a>
              </Typography>
            </Grid>

            {/* <Grid item xs={12} sm={12}  >

            </Grid> */}

            <Grid item xs={12} sm={12} className={classes.imgBack}>
              
              {/* /<ButtonBase className={classes.image} href={process.env.PUBLIC_URL +'/#/blog/' + data[id].id + '/show'}> */}
              <ButtonBase className={classes.image} href={'/blog/' + data[id].id + '/show'}>
                <img className={classes.img} alt="complex" src={ClubBlack} />
              </ButtonBase>
            </Grid>

            {/* <Grid item xs={12} sm={12} className={classes.space} >

            </Grid> */}

            <Grid item xs={12} sm={12} className={classes.blogBack}>
            <Typography variant="h5" className={classes.title} >
                <Box ml={1} >
                  {data[id].title}
                </Box>
              </Typography>

              <Typography variant="body2" gutterBottom>
                {
                  // var streetaddress= data[id].new.substr(0, addy.indexOf(','));

                  parse(data[id].new, options)}
              </Typography>
              {/* <a href={'/#/blog/' + data[id].id + '/show'}><MoreHorizIcon /></a> */}
            </Grid>

            <Grid item xs={12} sm={12} className={classes.spaceB} >

            </Grid>

          </Grid>
        {/* </div> */}
         </Paper>
        //)}
      ))}

    </div>
  );
};

export const BlogList = (props) => (
  <List {...props} title="All comments" pagination={<PostPagination />} actions={<ListActions />} title="test">
    <CommentGrid id='SS' />
  </List>
);